import { useEffect, useState } from "react";
import "./dialog-styles.css";
import * as Dialog from "@radix-ui/react-dialog";
import { EventBus } from "../game/EventBus";
import { EVENTS_NAME } from "../game/consts.ts";

// First-hostile tutorial: shown ONCE, the moment the player's client sees
// its first monster (GameMain pauses the scene and emits showMonsterIntro;
// closing this resumes it). Styled to match the Samosa GameIntro.
const INTRO_TEXT =
  "Whoa — DOWN! See that thing? That's the fleet. The mesh stopped hiding " +
  "in the cars and started DRIVING them. Three models are hunting the " +
  "streets: the SCHMESLA (fast, aggressive, allegedly self-driving), the " +
  "MODELT9 (a hundred years old and it will NOT stop), and the LOLvo — a " +
  "station wagon built like a bunker whose 'collision avoidance' system " +
  "shoots AT you. Watch the red bar over the hood — that's its health, not " +
  "yours.\n\n" +
  "Good news: they're still just hardware. Get in close and hit SPACEBAR to " +
  "smash one (on a phone, DOUBLE-TAP the screen). Every wreck pays a score " +
  "bounty. If one's grinding on you, RUN — they lose the plot when you keep " +
  "moving. Strafe sideways to dodge LOLvo fire. And if they waste you, " +
  "you'll wake up back at the Impound Lot with a nearly-empty tank. If " +
  "you're leaking, look for a FIRST AID STATION — posted next to the fuel " +
  "pumps, +25 health a patch, once a minute. Don't get wasted.";

function MonsterIntro() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onShow = () => setOpen(true);
    EventBus.on(EVENTS_NAME.showMonsterIntro, onShow);
    return () => {
      EventBus.removeListener(EVENTS_NAME.showMonsterIntro, onShow);
    };
  }, []);

  const close = () => {
    setOpen(false);
    // resume the paused GameMain scene
    EventBus.emit(EVENTS_NAME.monsterIntroClosed);
  };

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(o) => {
        if (!o) close();
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay" />
        <Dialog.Content
          className="DialogContent"
          style={{
            border: "2px solid #ff3333",
            color: "var(--ro-text)",
            fontFamily: "MelGame, Courier New, monospace",
            boxShadow: "0 0 40px rgba(255,50,50,0.45)",
          }}
        >
          <Dialog.Title
            style={{
              fontSize: "36px",
              marginBottom: "20px",
              textAlign: "center",
              color: "#ff5555",
              fontStyle: "italic",
              textShadow: "0 0 12px rgba(255,60,60,0.7)",
            }}
          >
            ⚠ HOSTILES DETECTED ⚠
          </Dialog.Title>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(100% - 100px)",
            }}
          >
            <div style={{ flex: 1, overflow: "auto" }}>
              <p
                style={{
                  margin: "0",
                  color: "var(--ro-text)",
                  lineHeight: "1.6",
                  fontSize: "20px",
                  textAlign: "justify",
                  whiteSpace: "pre-wrap",
                }}
              >
                {INTRO_TEXT}
              </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <button
                onClick={close}
                style={{
                  backgroundColor: "var(--ro-panel-solid)",
                  color: "#ff5555",
                  border: "1px solid #ff3333",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  fontSize: "18px",
                  letterSpacing: "0.08em",
                }}
              >
                UNDERSTOOD — LET ME AT 'EM
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default MonsterIntro;
